/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function UserIsActiveDtoFromJSON(json) {
    return UserIsActiveDtoFromJSONTyped(json, false);
}
export function UserIsActiveDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'userName': !exists(json, 'userName') ? undefined : json['userName'],
        'isActive': !exists(json, 'isActive') ? undefined : json['isActive'],
    };
}
export function UserIsActiveDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'userName': value.userName,
        'isActive': value.isActive,
    };
}
